import(/* webpackMode: "eager" */ "/home/runner/work/hiburim/hiburim/src/app/c/[[...id]]/page.tsx")